export default __webpack_public_path__ + "static/media/earthling_3.1f532bd6.png";